import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';

function CustomCheckbox({ value, onChange, ...props }) {
	return (
	  <Checkbox
		checked={!!value}
		onChange={(e) => onChange(e.target.checked)}
		{...props}
	  />
	);
};


export default CustomCheckbox;
